import React from 'react';
import Layout from '../layout/layout';
import { graphql, Link } from 'gatsby';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { StaticImage } from 'gatsby-plugin-image';

const AboutPage = ({ data: {about}}) => {
    console.log(about);
    return (
        <Layout title="About Me" showFooter={false}>
            <div className='about'>
                <div className='container'>
                    <div className='about__wrapper'>
                        <div className='about__image'>
                            <StaticImage height={450} src="../images/me.jpeg" alt="Kevin" />
                        </div>
                        <div className='about__summary'>
                            { renderRichText(about.summary)}
                            <Link to="/contact" className="btn">Contact Me</Link>
                        </div>
                        
                    </div>
                </div>
            </div>
        </Layout>
    )
}



export const aboutQuery = graphql`
query{
    about: contentfulAbout(title: {eq: "About"}) {
        summary {
            raw
        }
    }
}
`;

export default AboutPage;